import * as userRequest from "@/utils/userRequest";

export default async function getCouponService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("boost/coupons", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ getCouponService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
